<template>
  <VisibleModal />
  <div class="modal__overlay">
    <div class="modal" @click.stop="''">
      <div class="modal__header">
        <h3>{{ $t('onboardingModal.WELCOME') }}</h3>
        <i class="material-icons close" @click.stop="closeOnboardingModal()">close</i>
      </div>
      <div v-if="contentLoaded" v-html="content"></div>
      <Loader v-else-if="!reqError"/>
      <div v-else class="modal__error"><i class="material-icons">error_outline</i> {{ $t('onboardingModal.LOAD_ERROR') }}</div>
    </div>
  </div>
</template>

<script>
import VisibleModal from '@/components/VisibleModal.vue';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex'
import Loader from '../components/Loader.vue';

export default {
  components: {
      VisibleModal,
      Loader
  },
  setup(_, { emit }) {
    const store = useStore();
    const content = ref();
    const contentLoaded = ref(false);
    const reqError = ref(false);

    function closeOnboardingModal(){
      emit('closeOnboardingModal');
    }

    onMounted(async()=>{
      try {
        let req = await store.dispatch('stuff_onboarding');
        content.value = req.data.data;
        contentLoaded.value = true;        
      } catch (error) {
        console.log(error);
        reqError.value = true;
      }
    })

    return {
      closeOnboardingModal,
      content,
      contentLoaded,
      reqError,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/main.scss";

.modal{
  margin-top: -5vh;
  width: 96%;
  max-width: 800px;
  height: fit-content;
  max-height: 90vh;
  padding: 22px;
  padding-top: 12px;
  background: #fff;
  border-radius: 10px;
  &__header{
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    h3{
      font-weight: 700;
      font-size: 17px;
    }
    .close{
      font-size: 22px;
      font-weight: 500;
      cursor: pointer;
    }
  }
  &__error{
    padding: 6px 0;
    @include icon-and-text-container;
    justify-content: center;
    color: #D12300;
  }
}

</style>